module.exports = __webpack_public_path__ + "static/media/no-ad-found.097b9e85.png";